export const SERVICE_PAGES = {
  "tiktok-shop-setup": {
    slug: "tiktok-shop-setup",
    seoTitle: "TikTok Shop 马来西亚开店咨询 | TikTok Shop Setup Malaysia | TKShopMY",
    seoDesc: "TKShopMY 为马来西亚卖家提供 TikTok Shop 开店咨询：申请流程、资料准备、店铺设置及上线前检查。TikTok Shop setup Malaysia，合作前先了解清楚。",
    keywords: "TikTok Shop 马来西亚, TikTok Shop 开店, TikTok Shop 怎么开, TikTok Shop setup Malaysia, TikTok Shop registration Malaysia",
    h1: "TikTok Shop 马来西亚开店，从第一天就做对",
    kicker: "TikTok Shop 开店咨询",
    intro: "开一间 TikTok Shop 不难。难的是一开始就选对类别、设置好店铺资料、配置好物流，避免上架两星期后全部重做 —— 大部分马来西亚新卖家就是卡在这里。我们的开店咨询会在你上线前，陪你把每个决定看清楚。",
    includesTitle: "开店咨询包括什么",
    includes: [
      "卖家账号申请 —— 个人卖家还是公司（SSM），哪个适合你的情况",
      "资料准备 —— 身份文件、银行户口、特定类别所需的认证",
      "店铺资料设置 —— 店名、标志方向、店铺简介、取货与退货设置",
      "物流和收款配置，用简单的语言解释清楚",
      "商品类别选择和第一批上架结构",
      "上线前检查清单，确保没有遗漏重要步骤",
    ],
    whoFor: [
      "第一次在马来西亚开 TikTok Shop 的新卖家",
      "第一次把生意搬到线上的实体商家",
      "申请或设置到一半卡住的卖家",
      "希望在扩展前把店铺结构做对的品牌",
    ],
    process: [
      { title: "先聊聊", desc: "告诉我们你打算卖什么，目前进行到哪一步。" },
      { title: "帮你理清开店步骤", desc: "列出你这个情况需要的步骤、资料和决定。" },
      { title: "陪你完成设置", desc: "上线前帮你把店铺检查一遍。" },
    ],
    faqs: [
      {
        q: "在马来西亚注册 TikTok Shop 需要多久？",
        a: "资料准备好后，申请本身不到一小时可以完成。平台审核时间由 TikTok Shop 决定，长短不一。我们的工作是确保你的提交完整，避免可以避免的延迟。",
      },
      {
        q: "你们可以保证我的店铺申请通过吗？",
        a: "不能。审核完全由 TikTok Shop 根据他们自己的标准决定。我们做的是确保你的资料、类别选择和店铺信息正确完整 —— 这去除了申请被卡住的最常见原因。",
      },
      {
        q: "开 TikTok Shop 需要 SSM 吗？",
        a: "个人卖家没有 SSM 也可以注册，但注册公司能使用更多类别和功能。我们会根据你卖的产品，解释哪条路更合适。",
      },
    ],
  },
  "tiktok-shop-management": {
    slug: "tiktok-shop-management",
    seoTitle: "TikTok Shop 代运营与店铺管理 马来西亚 | TKShopMY",
    seoDesc: "TKShopMY 提供 TikTok Shop 马来西亚代运营与店铺管理服务（TikTok Shop management Malaysia）：日常运营、店铺优化、活动与促销规划，由本地电商团队执行。",
    keywords: "TikTok Shop 代运营 马来西亚, TikTok Shop 运营, TikTok Shop 管理, TikTok Shop management Malaysia, TikTok Shop agency Malaysia",
    h1: "TikTok Shop 代运营与店铺管理",
    kicker: "店铺管理与日常运营",
    intro: "TikTok Shop 不会自己运转。订单、客服消息、评价、平台活动、商品维护、库存同步 —— 这些日常工作决定了店铺是成长还是停滞。TKShopMY 提供持续的店铺管理和运营支持，即使你忙着处理生意的其他部分，店铺也继续正常运作。",
    includesTitle: "店铺管理包括什么",
    includes: [
      "日常运营流程 —— 订单、客户消息、评分与评价",
      "店铺优化 —— 资料、商品结构、标题、描述和图片",
      "活动与促销规划 —— 优惠券、套装组合和平台活动档期",
      "商品维护 —— 价格、库存和商品页面更新",
      "每周优先事项 —— 该修什么、该推什么、什么先放着",
      "清楚的汇报 —— 做了什么，改变了什么",
    ],
    whoFor: [
      "有店铺但没时间每天管理的卖家",
      "没有内部电商团队的 SME",
      "有流量但转化不好的店铺",
      "希望日常运营保持稳定专业的品牌",
    ],
    process: [
      { title: "店铺检查", desc: "我们先看你店铺目前的状态，找出缺口。" },
      { title: "确认服务范围", desc: "开始前你就清楚知道哪些部分由我们处理。" },
      { title: "持续运营", desc: "按谈好的节奏执行，并定期向你汇报。" },
    ],
    faqs: [
      {
        q: "TikTok Shop 代运营每天实际做什么？",
        a: "处理日常运营工作：保持商品信息准确、及时回复店内消息、为活动档期做准备、维护店铺形象、及早发现问题。具体范围会在开始前和你确认清楚。",
      },
      {
        q: "你们需要我的 TikTok 账号密码吗？",
        a: "权限安排会在工作开始前透明地讨论，并按照你舒服的方式进行。我们不会要求超出服务范围的权限。",
      },
      {
        q: "代运营可以保证销量增长吗？",
        a: "没有人可以诚实地保证这一点 —— TikTok Shop 的流量和销量取决于平台、你的产品和市场。代运营做的是把运营基础稳定地做好，这才是店铺能成长的前提。",
      },
    ],
  },
  "product-optimisation": {
    slug: "product-optimisation",
    seoTitle: "TikTok Shop 商品优化 马来西亚 | TKShopMY",
    seoDesc: "TKShopMY 为马来西亚卖家提供 TikTok Shop 商品优化服务：改善商品标题、描述、图片和上架结构，让商品页面更清楚、更能促成下单。",
    keywords: "TikTok Shop 商品优化, TikTok Shop 商品上架, TikTok Shop product optimisation Malaysia, 商品页面优化",
    h1: "让客户一看就明白、愿意下单的商品页面",
    kicker: "商品上架与优化",
    intro: "马来西亚大部分 TikTok Shop 商品页面都输在同一个地方：标题不清楚、描述太简单、照片回答不了买家的问题。商品优化就是把页面本身修好 —— 流量进来的时候，商品页面要做得到位。",
    includesTitle: "我们优化什么",
    includes: [
      "商品标题 —— 符合马来西亚买家的搜索习惯，清楚易读",
      "商品描述 —— 完整、容易扫读，回答买家真正会问的问题",
      "商品图片 —— 该展示什么、按什么顺序、每张图要传达什么",
      "规格与价格结构 —— 让客户容易做选择",
      "上架完整度 —— 填满每个影响曝光和转化的栏位",
      "类别和属性准确性，争取更好的展示位置",
    ],
    whoFor: [
      "商品有浏览量但订单少的卖家",
      "SKU 很多、当初匆忙上架的商家",
      "希望商品目录保持专业一致的品牌",
      "希望一开始就把商品页面做对的新卖家",
    ],
    process: [
      { title: "商品页面检查", desc: "检查你现有的商品页面，找出每个页面缺什么。" },
      { title: "优化方案", desc: "给你一份按影响排序的清楚修改清单。" },
      { title: "执行支持", desc: "协助重构标题、描述和图片方向。" },
    ],
    faqs: [
      {
        q: "怎样改善 TikTok Shop 商品页面？",
        a: "从基础开始：符合买家搜索习惯的标题、能回答前三个问题的图片、消除疑虑的描述。我们的优化服务会把这套流程系统地应用到你的整个商品目录。",
      },
      {
        q: "改善商品页面真的能提高转化吗？",
        a: "购买决定发生在商品页面上。更清楚的标题、更好的图片和完整的信息会减少犹豫。它救不了弱产品，但能阻止好产品被埋没。",
      },
    ],
  },
  "content-strategy": {
    slug: "content-strategy",
    seoTitle: "TikTok Shop 内容规划 马来西亚 | TKShopMY",
    seoDesc: "TKShopMY 为马来西亚卖家规划 TikTok Shop 内容方向：短视频角度、内容形式和发布节奏，配合你的产品和马来西亚市场。",
    keywords: "TikTok Shop 内容规划, TikTok 短视频方向, TikTok Shop content strategy Malaysia, 马来西亚 TikTok 内容",
    h1: "围绕你的产品，规划内容方向",
    kicker: "内容方向规划",
    intro: "在 TikTok Shop，内容就是店面。但大部分卖家不是随便发，就是模仿不适合自己产品的形式。我们的内容规划服务帮你定方向：什么角度适合你的产品、你的客户对什么形式有反应、以及一个你确实做得到的发布节奏。",
    includesTitle: "内容方向包括什么",
    includes: [
      "根据你的产品和目标客户规划内容角度",
      "形式建议 —— 演示、痛点解决、对比、幕后日常",
      "符合你团队能力的实际发布节奏",
      "短视频的开头和结构指导",
      "适合你类别的直播方向建议",
      "配合马来西亚节日和发薪日的每月内容主题",
    ],
    whoFor: [
      "不知道什么内容适合自己产品的卖家",
      "持续发视频但没有反应的店铺",
      "想建立一致内容形象的品牌",
      "在自己做内容和找创作者之间犹豫的商家",
    ],
    process: [
      { title: "了解产品和客户", desc: "我们先研究你卖什么、谁在买。" },
      { title: "内容方向文件", desc: "你会得到清楚的角度、形式和发布计划。" },
      { title: "持续调整", desc: "根据实际表现修正方向。" },
    ],
    faqs: [
      {
        q: "你们会帮我们拍视频吗？",
        a: "我们的核心服务是方向和规划 —— 角度、形式、开头和节奏。制作安排可以按你的需求另外讨论，但先有策略，制作才不会浪费力气。",
      },
      {
        q: "马来西亚 TikTok Shop 做什么内容有效？",
        a: "很看产品。演示类和痛点解决类普遍有效；具体做法 —— 语言、价格呈现、幽默还是信息型 —— 取决于你的客户群。这正是内容方向规划要回答的问题。",
      },
    ],
  },
};
